import { ThemedIcon } from "@me8eon/icons";
import React, { useCallback } from "react";
import { useTranslation } from "@me8eon/translation";
import { useFirstName } from "../../../../components/ai-assist-refactored/hooks/useFirstName";
import { Card } from "../../../../shared/ui/atoms/Card";
import { AiSuggestionIssue, aiSuggestionIssueMap } from "../../model/constants";
import { useDoAi } from "@me8eon/react_intent";
import styles from "./NoMessages.module.scss";
import { useLoadingFlag } from "@me8eon/async";
import { useLanguage } from "@me8eon/language";

export const NoMessages = () => {
    const [loading] = useLoadingFlag()
    const firstName = useFirstName();
    const t = useTranslation();
    const [language] = useLanguage();
    const handleAiQuery = useDoAi();

    const handleCardClick = useCallback((issue: AiSuggestionIssue) => {
        if (loading) return;
        if (!issue.question) return;
        handleAiQuery(issue.question);
    }, [handleAiQuery]);

    const issues = aiSuggestionIssueMap.get(language);

    return (
        <div className={styles.noMessages}>
            <div className={styles.noMessages__welcome}>
                <ThemedIcon name="AiIcon64" />
                <span title={t("chatBot.topicStartMessage")} className="start-message">
                    {t("chatBot.hey")} {firstName},{" "}
                    {t("chatBot.topicStartMessage")}
                </span>
            </div>

            <div className={styles.noMessages__cards} id="tileTour8">
                {issues?.map((issue) => (
                    <Card
                        key={issue.id}
                        onClick={() => handleCardClick(issue)}
                        className={styles.noMessages__card}
                    >
                        {issue.question}
                    </Card>
                ))}
            </div>
        </div>
    )
}